import { render, staticRenderFns } from "./platformCustomization.vue?vue&type=template&id=5334f51b&scoped=true"
import script from "./platformCustomization.vue?vue&type=script&lang=js"
export * from "./platformCustomization.vue?vue&type=script&lang=js"
import style0 from "./platformCustomization.vue?vue&type=style&index=0&id=5334f51b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334f51b",
  null
  
)

export default component.exports